import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { DocumentCategoryDTO } from "../assistist/DocumentCategory";

const PATH = "document-categories";

@Injectable({
  providedIn: "root",
})
export class DocumentCategoryHandlerService {
  constructor(private APIService: ApiService) {}

  getDocumentCategories(
    masterAccountID: number,
    integrationID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
      sort?: string | string[];
      keyword?: string;
      filter_columns?: string[];
      forCount?: boolean;
    },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${integrationID}`, {
      params: queryParams,
    });
  }

  getDocumentCategory(masterAccountID: number, integrationID: number, documentCategoryID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${integrationID}/${documentCategoryID}`);
  }

  deleteDocumentCategory(masterAccountID: number, integrationID: number, documentCategoryID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${integrationID}/${documentCategoryID}`);
  }

  postDocumentCategory(masterAccountID: number, integrationID: number, documentCategoryDTO: DocumentCategoryDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${integrationID}`, documentCategoryDTO);
  }

  putDocumentCategory(masterAccountID: number, integrationID: number, documentCategoryDTO: DocumentCategoryDTO) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${integrationID}/${documentCategoryDTO.id}`,
      documentCategoryDTO,
    );
  }

  getTagsAutocomplete(masterAccountID: number, integrationID: number, documentCategoryID: number, queryParams?: { keyword?: string }) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${integrationID}/${documentCategoryID}/tags/autocomplete`, {
      params: queryParams,
    });
  }

}
